import { Box, Typography, IconButton } from '@mui/material';
import InputContainer from '../../InputContainer';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';


//function QuestionFreeTextOption(props) {
export default function QuestionFreeTextOption({ option, type, answerHidden, optionList, editMode, onQVariableSelect }) {

    const clickRemoveOption = (e, origQVariable, optionType) => {
        onQVariableSelect(null, origQVariable, optionType);
    }

    const handleOptionTextChanged = (value, qVariable) => {

        let oldValue = qVariable;
        let newValue = JSON.parse(JSON.stringify(qVariable));
        newValue.label = value;
        newValue.quizzlerObject.label = value;
        onQVariableSelect(newValue, oldValue, type);

    }


    const generateOptionTextChange = (qVariable) => {

        return <InputContainer tiny value={qVariable.label} onBlur={(value) => handleOptionTextChanged(value, qVariable)} />;

    }

    const generateOption = (origQVariable) => {

        return (

            <Box>

                <Box sx={{ display: 'flex', height: editMode ? 40 : 30, alignItems: 'center' }}>

                    {type === 'DISTRACTOR' && editMode && optionList.length > 2 &&

                        <IconButton aria-label="remove" size="small" onClick={(e) => clickRemoveOption(e, origQVariable, type)}><DeleteOutlinedIcon fontSize="small" /></IconButton>

                    }

                    {type === 'DISTRACTOR' && editMode && optionList.length <= 2 &&

                        <Box style={{ width: 30 }}></Box>

                    }

                    {type === 'CORRECT_OPTION' && editMode &&

                        <Box style={{ width: 30 }}></Box>

                    }

                    {editMode && generateOptionTextChange(origQVariable)}

                    {!editMode && <Box sx={{ alignSelf: 'center' }}><Typography sx={!answerHidden && type === 'CORRECT_OPTION' ? { fontWeight: 'bold', color: 'green' } : {}}>{option.label}</Typography></Box>}


                </Box>

            </Box >

        )

    }


    return generateOption(option.qv);


}